export default __webpack_public_path__ + "static/intelligent-automation-2-0c6550a583d77f962bc0dd3a46c99c7d.webp";